/**
 * Version Module.
 *
 * Injected at build time by webpack's DefinePlugin from package.json, which is the
 * single source of truth. It used to be hand-maintained here while
 * .github/scripts/generate-sri.mjs read package.json and the deploy tag carried a
 * third value - so the three could drift. That matters because Sentry sourcemaps
 * are uploaded per release: a version mismatch makes symbolication fail silently.
 *
 * Guarded with `typeof` so the module still resolves with no DefinePlugin present.
 * Under Jest the same global is supplied from package.json by jest.setup.ts, so
 * tests and the bundle agree by construction rather than by discipline.
 *
 * Note this string is also published to client pages as the `diagnosticVersion`
 * session attribute (see src/session.ts), so its format must stay bare - '2.8.4',
 * never 'v2.8.4'.
 */
declare const __FOUNTAIN_VERSION__: string;

export const VERSION: string =
    typeof __FOUNTAIN_VERSION__ !== 'undefined' ? __FOUNTAIN_VERSION__ : '0.0.0';
